export class PollQuestion {
  title: string = '';
  type: string = '';
  questions?: string[];
}
